import { render, staticRenderFns } from "./app-main.vue?vue&type=template&id=4d0b122c&"
var script = {}
import style0 from "./app-main.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports